(function () {
  var popup = document.getElementById('NewsletterPopup');
  if (!popup) return;

  var config = window.NewsletterPopupConfig || {};
  var storageKey = config.storageKey || 'newsletter_popup_closed_at';
  var subscribedKey = 'newsletter_popup_subscribed';
  var submittedKey = 'newsletter_popup_submitted';
  var delaySec = typeof config.delay === 'number' ? config.delay : 3;
  var reshowDays = typeof config.reshowDays === 'number' ? config.reshowDays : 0;
  var sourceSelector = config.sourceSelector || '.p-footer__letter';
  var mode = config.hideInSource || 'form_only';

  var isEditor = window.Shopify && Shopify.designMode;
  var slot = popup.querySelector('[data-newsletter-slot]');

  // -------------------------
  // 状態判定
  // -------------------------
  var source = document.querySelector(sourceSelector);

  // ポップアップから送信した直後か
  var submittedFromPopup = false;
  try {
    submittedFromPopup = sessionStorage.getItem(submittedKey) === '1';
    if (submittedFromPopup) sessionStorage.removeItem(submittedKey);
  } catch (e) {}

  // 登録が成功したか（Shopifyは成功時に customer_posted=true を付与）
  var postedSuccess =
    window.location.search.indexOf('customer_posted=true') !== -1 ||
    !!(source && source.querySelector('form h3'));

  // 登録成功ならフラグ保存（フッター経由でも登録済み扱い）
  if (postedSuccess) {
    try { localStorage.setItem(subscribedKey, '1'); } catch (e) {}
  }

  function isSubscribed() {
    try { return localStorage.getItem(subscribedKey) === '1'; } catch (e) { return false; }
  }

  // ポップアップ経由の登録成功 → クーポン表示モード
  var showCoupon = submittedFromPopup && postedSuccess;

  // -------------------------
  // クーポンブロック生成
  // -------------------------
  function buildCouponBlock() {
    var wrapper = document.createElement('div');
    wrapper.className = 'newsletter-popup__coupon';

    if (config.couponHeading) {
      var h = document.createElement('p');
      h.className = 'newsletter-popup__coupon-heading';
      h.textContent = config.couponHeading;
      wrapper.appendChild(h);
    }

    if (config.couponDescription) {
      var d = document.createElement('div');
      d.className = 'newsletter-popup__coupon-desc';
      d.innerHTML = config.couponDescription;
      wrapper.appendChild(d);
    }

    if (config.couponCode) {
      var box = document.createElement('div');
      box.className = 'newsletter-popup__coupon-box';

      var codeLabel = document.createElement('p');
      codeLabel.className = 'newsletter-popup__coupon-label';
      codeLabel.textContent = 'CODE';
      box.appendChild(codeLabel);

      var codeText = document.createElement('p');
      codeText.className = 'newsletter-popup__coupon-code';
      codeText.textContent = config.couponCode;
      box.appendChild(codeText);

      var copyBtn = document.createElement('button');
      copyBtn.type = 'button';
      copyBtn.className = 'newsletter-popup__coupon-copy';
      copyBtn.textContent = 'クーポンコードをコピー';
      copyBtn.addEventListener('click', function () {
        var code = config.couponCode;
        var doneLabel = 'コピーしました';
        var backLabel = 'クーポンコードをコピー';
        var done = function () {
          copyBtn.textContent = doneLabel;
          setTimeout(function () { copyBtn.textContent = backLabel; }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            fallbackCopy(code);
            done();
          });
        } else {
          fallbackCopy(code);
          done();
        }
      });
      box.appendChild(copyBtn);

      wrapper.appendChild(box);
    }

    if (config.couponNote) {
      var n = document.createElement('p');
      n.className = 'newsletter-popup__coupon-note';
      n.textContent = config.couponNote;
      wrapper.appendChild(n);
    }

    return wrapper;
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  // -------------------------
  // ポップアップ内容の構築
  // -------------------------
  function buildContent() {
    // クーポン表示モード
    if (showCoupon) {
      slot.innerHTML = '';
      slot.appendChild(buildCouponBlock());

      var popupTitle = popup.querySelector('.newsletter-popup__title');
      if (popupTitle) popupTitle.style.display = 'none';
      var popupDesc = popup.querySelector('.newsletter-popup__desc');
      if (popupDesc) popupDesc.style.display = 'none';
      var popupNote = popup.querySelector('[data-newsletter-note]');
      if (popupNote) popupNote.style.display = 'none';
      return true;
    }

    // 通常モード（フッターからフォームをクローン）
    if (!source) {
      console.warn('[NewsletterPopup] source not found:', sourceSelector);
      return false;
    }

    var clone;
    if (mode === 'form_only') {
      var form = source.querySelector('form');
      if (!form) return false;
      clone = form.cloneNode(true);
    } else {
      clone = source.cloneNode(true);
    }

    // ID衝突回避
    clone.querySelectorAll('[id]').forEach(function (el) {
      el.id = el.id + '--popup';
    });
    clone.querySelectorAll('label[for]').forEach(function (el) {
      el.setAttribute('for', el.getAttribute('for') + '--popup');
    });

    // ボタンラベル書き換え
    if (config.buttonLabel) {
      var btn = clone.querySelector('button[type="submit"], .p-footer__letterBtn, #Subscribe--popup');
      if (btn) btn.textContent = config.buttonLabel;
    }

    // フッター側の見出し・説明・注記を非表示
    var ttl = clone.querySelector('.p-footer__ttl');
    if (ttl) ttl.style.display = 'none';
    var descEl = clone.querySelector('.p-footer__desc');
    if (descEl) descEl.style.display = 'none';
    if (config.hideFooterNote) {
      var noteEl = clone.querySelector('.p-footer__note');
      if (noteEl) noteEl.style.display = 'none';
    }

    // フッター由来の完了メッセージは消す
    var successMsg = clone.querySelector('h3');
    if (successMsg) successMsg.remove();

    // 入力値をクリア
    var emailInput = clone.querySelector('input[type="email"]');
    if (emailInput) emailInput.value = '';

    slot.appendChild(clone);

    // 送信時に「ポップアップから送信した」ことを記録
    var popupForm = slot.querySelector('form');
    if (popupForm) {
      popupForm.addEventListener('submit', function () {
        try { sessionStorage.setItem(submittedKey, '1'); } catch (e) {}
      });
    }
    return true;
  }

  // -------------------------
  // 表示制御
  // -------------------------
  function shouldShow() {
    if (isEditor) return true;
    if (showCoupon) return true;          // 登録直後のクーポン表示は1回だけ出す
    if (isSubscribed()) return false;     // 登録済みは表示しない
    if (reshowDays === 0) return true;
    try {
      var closedAt = parseInt(localStorage.getItem(storageKey), 10);
      if (isNaN(closedAt)) return true;
      return (Date.now() - closedAt) / 86400000 >= reshowDays;
    } catch (e) { return true; }
  }

  function open() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }

  function close() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    if (!isEditor && reshowDays > 0) {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
    }
  }

  if (!shouldShow()) return;
  if (!buildContent()) return;

  if (showCoupon) {
    open();
  } else {
    setTimeout(open, delaySec * 1000);
  }

  // 閉じるボタン
  popup.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // Escキー
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
  });

  // テーマ編集用
  if (isEditor) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(popup)) open();
    });
  }
})();